import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-grid-system';
import Section from '../Section';

import styles from './quote.module.scss';

function Quote(props) {
  const {
    author,
    company,
    position,
    text,
  } = props;
  return (
    <div className={styles.quote}>
      <Section size="small">
        <Col>
          <div className={styles.container}>
            <div className={styles.content}>{text}</div>
            {author && (
              <div className={`${styles.text} ${styles.author} `}>{author}</div>
            )}
            {position && (
              <div className={styles.text}>{position}</div>
            )}
            {company && (
              <div className={styles.text}>{company}</div>
            )}
          </div>
        </Col>
      </Section>
    </div>
  );
}

export default Quote;

Quote.propTypes = {
  author: PropTypes.string,
  company: PropTypes.string,
  position: PropTypes.string,
  text: PropTypes.string.isRequired,
};

Quote.defaultProps = {
  author: '',
  company: '',
  position: '',
};
